import Alpine from 'alpinejs';
import Collapse from '@alpinejs/collapse';
import Slide from './alpine/directives/slide';
import { AjaxMethod, AjaxRequest, AjaxResponseType } from './modules/ajax';
import './extensions/number';
import './extensions/date';
(function () {
    var templates = document.querySelectorAll('svg template');
    var el, template, attribs, attrib, count, child, content;
    for (var i = 0; i < templates.length; i++) {
        el = templates[i];
        template = el.ownerDocument.createElement('template');
        el.parentNode.insertBefore(template, el);
        attribs = el.attributes;
        count = attribs.length;
        while (count-- > 0) {
            attrib = attribs[count];
            template.setAttribute(attrib.name, attrib.value);
            el.removeAttribute(attrib.name);
        }
        el.parentNode.removeChild(el);
        content = template.content;
        while ((child = el.firstChild)) {
            content.appendChild(child);
        }
    }
})();
Alpine.plugin(Slide);
Alpine.plugin(Collapse);
window.Alpine = Alpine;
Alpine.data('form', function () { return ({
    apiUrl: "https://skekraftwp.bmdev.se",
    //apiUrl: "http://localhost:33676",
    //apiUrl: "https://www.skekraft.se",
    loading: false,
    data: null,
    step: 0,
    steps: [
        {
            valid: true,
        },
        {
            valid: false,
        },
        {
            valid: false,
        },
        {
            valid: false,
        },
        {
            valid: true,
        },
    ],
    productGroups: null,
    offer: null,
    invoiceMethods: null,
    estimatedConsumption: 0,
    consumptionMultiplier: 30,
    aptSize: null,
    showAptSize: false,
    signId: null,
    externalId: null,
    showComplete: false,
    showSummary: false,
    showSign: false,
    showSignError: false,
    mobile: false,
    base64QRCode: "",
    bankIdAutoStartToken: "",
    showAgreementError: false,
    agreementErrors: [],
    leaseStartDate: null,
    formValid: false,
    summary: {
        additionalProducts: [],
        accept: false,
    },
    form: {
        details: {
            name: "",
            email: "",
            phone: "",
            ssn: "",
            address: "",
            zipCode: "",
            city: ""
        },
        start: {
            value: (new Date()).toFormat("yyyy-MM-dd"),
            error: "",
            valid: false,
            validated: false,
        },
        facility: {
            value: "",
            error: "",
            valid: false,
            validated: false,
        },
        netArea: {
            value: "",
            error: "",
            valid: false,
            validated: false,
        },
        invoice: {
            title: "",
            value: "",
            value2: "",
            email: "",
            sms: "",
            error: "",
            valid: false,
            validated: false,
        },
        product: {
            value: "",
            error: "",
            valid: false,
            validated: false,
        },
    },
    twelveMonths: false,
    init: function () {
        var _this = this;
        /*
        name Full name of the tenant.
        ssn Personal identifier (personal number in case of Swedish residents).
        email Tenant’s email address.
        phone Tenant’s phone number.
        street Street name (including house number).
        city City name.
        post_code Post code.
        apt_size
        */
        this.loading = true;
        this.mobile = this.isMobile({ tablet: true, featureDetect: true });
        var query = window.location.search;
        var params = new URLSearchParams(query);
        this.form.details.ssn = params.get("ssn");
        this.form.details.name = params.get("name");
        this.form.details.email = params.get("email");
        this.form.details.phone = params.get("phone");
        this.form.details.address = params.get("street");
        this.form.details.zipCode = params.get("post_code");
        this.form.details.city = params.get("city");
        var campaign = params.get("campaign") ? params.get("campaign") : "default";
        this.externalId = params.get("request_id");
        this.leaseStartDate = null; //params.get("lease_starts_at");
        this.consumptionMultiplier = 30;
        this.aptSize = params.get("apt_size") || params.get("apt_size") == "0" ? parseInt(params.get("apt_size")) : 50;
        this.showAptSize = !params.get("apt_size") || params.get("apt_size") == "0";
        this.aptSizeChanged();
        var offset = 21;
        if (this.leaseStartDate != null) {
            try {
                this.firstDate = new Date(this.leaseStartDate).toFormat("yyyy-MM-dd");
                this.firstPossible = new Date(this.leaseStartDate).toFormat("yyyy-MM-dd");
            }
            catch (_a) {
                alert("Invalid lease start date.");
                return;
            }
        }
        else {
            this.firstDate = (new Date(new Date().setDate(new Date().getDate() + offset))).toFormat("yyyy-MM-dd");
            this.firstPossible = (new Date(new Date().setDate(new Date().getDate() + offset))).toFormat("yyyy-MM-dd");
        }
        this.form.start.value = this.firstPossible;
        this.validateDate();
        this.getProducts(campaign, this.form.details.zipCode).then(function (results) {
            console.log("results", results);
            if (results.data.success) {
                _this.data = results.data.result;
                _this.offer = _this.data.offer;
                _this.invoiceMethods = _this.data.invoiceMethods;
                //Reverese order
                _this.data.offerProducts.productGroups.forEach(function (group) {
                    if (group.key == "basprodukt") {
                        group.types = group.types.reverse();
                    }
                });
                _this.productGroups = _this.parseProducts(_this.data, _this.estimatedConsumption);
            }
            _this.loading = false;
        }, function (error) {
            console.log("error", error);
            _this.loading = false;
        });
        var campaignStart = new Date(2023, 11, 1);
        var campaignEnd = new Date(2024, 0, 6);
        var dateNow = new Date();
        this.twelveMonths = dateNow >= campaignStart && dateNow < campaignEnd;
        var infoButtons = document.querySelectorAll(".info-btn");
        infoButtons.forEach(function (button) {
            button.addEventListener("click", function (event) {
                _this.resizeInfoBoxes();
            });
        });
        addEventListener("resize", function (event) {
            _this.resizeInfoBoxes();
        });
    },
    resizeInfoBoxes: function () {
        var boxes = document.querySelectorAll(".info-box");
        var width = document.documentElement.clientWidth;
        var height = document.documentElement.clientHeight;
        if (boxes.length > 0) {
            boxes.forEach(function (el) {
                var box = (el);
                var display = box.style.display;
                if (display == "none") {
                    box.style.display = "block";
                    box.style.visibility = "hidden";
                }
                console.log("display: ", box.style.display);
                var rect = box.getBoundingClientRect();
                var parent = box.parentElement.getBoundingClientRect();
                var distance = 34;
                if (parent.left > width / 2) {
                    var left = Math.abs(rect.width - (width - (parent.left + distance)));
                    left = left < (rect.width - distance) ? left : (rect.width - distance);
                    box.style.left = (left * -1) + "px";
                    var arrowLeft = Math.abs(left - ((parent.width - 4) / 2));
                    box.style.setProperty("--arrowLeft", arrowLeft + "px");
                }
                else {
                    var over = (parent.left + rect.width + distance) > width ? (parent.left + rect.width + distance) - width : distance;
                    var left = over;
                    box.style.left = (left * -1) + "px";
                    var arrowLeft = Math.abs(left - ((parent.width - 4) / 2));
                    box.style.setProperty("--arrowLeft", arrowLeft + "px");
                }
                if (display == "none") {
                    box.style.display = display;
                    box.style.visibility = "visible";
                }
            });
        }
    },
    getProducts: function (campaign, zipCode) {
        var url = this.apiUrl;
        var data = {
            "product-api": "postarealookup",
            zipcode: zipCode,
            code: campaign
        };
        var ajax = new AjaxRequest();
        return ajax.Send(AjaxMethod.GET, url, data, { ResponseType: AjaxResponseType.JSON });
    },
    parseProducts: function (data, estimatedConsumption) {
        var _this = this;
        var productGroups = [];
        data.offerProducts.productGroups.forEach(function (group) {
            if (group.key == "basprodukt") {
                //group.types = group.types.reverse();
                group.types.forEach(function (type) {
                    var productGroup = {
                        name: type.name + " Elpris",
                        selected: null,
                        selectedId: null,
                        products: [],
                    };
                    type.products.forEach(function (item) {
                        var product = {};
                        product.id = item.id;
                        product.name = item.name;
                        product.description = item.description;
                        product.years = item.length <= 0 ? "Löpande" : (item.length / 12) + " år";
                        product.addons = item.linkedAddons;
                        product.monthlyCosts = [];
                        product.variableCosts = [];
                        product.monthlyDiscounts = [];
                        product.variableDiscounts = [];
                        product.monthlyDiscountsTotal = 0;
                        product.variableDiscountsTotal = 0;
                        product.monthlyTotal = 0;
                        product.monthlyTotalWithDiscount = 0;
                        product.variableTotal = 0;
                        product.variableTotalWithDiscount = 0;
                        product.estimatedCost = 0;
                        product.estimatedCostWithDiscount = 0;
                        product.hasDiscount = false;
                        product.monthlyVat = 0;
                        product.variableVat = 0;
                        //Addons
                        product.addons.forEach(function (addon) {
                            var prices = [];
                            addon.data.forEach(function (price) {
                                price.types.forEach(function (type) {
                                    prices.push(type.value + " " + type.entity);
                                });
                            });
                            addon.price = prices.join(" + ");
                        });
                        //Fixa in priser
                        item.data.forEach(function (productData) {
                            productData.types.forEach(function (typeData) {
                                var cost = {};
                                cost.id = typeData.id;
                                cost.value = typeData.value;
                                cost.entity = typeData.entity;
                                cost.name = typeData.name;
                                switch (productData.key) {
                                    case "manadsavgift":
                                        product.monthlyCosts.push(cost);
                                        product.monthlyTotal += cost.value;
                                        break;
                                    case "lopande-avgift":
                                        product.variableCosts.push(cost);
                                        product.variableTotal += cost.value;
                                        break;
                                }
                            });
                        });
                        //Fixa in rabatter
                        item.autoDiscounts.forEach(function (autoDiscount) {
                            var discount = {};
                            discount.id = autoDiscount.id;
                            discount.length = autoDiscount.length;
                            discount.value = autoDiscount.value;
                            discount.entity = autoDiscount.entity;
                            discount.name = autoDiscount.name;
                            discount.title = "Rabatt " + autoDiscount.length + " mån";
                            switch (autoDiscount.entity) {
                                case "kr/mån":
                                case "kr/år":
                                case "öre/år":
                                    product.monthlyDiscounts.push(discount);
                                    product.monthlyDiscountsTotal += discount.value;
                                    break;
                                default:
                                    product.variableDiscounts.push(discount);
                                    product.variableDiscountsTotal += discount.value;
                                    break;
                            }
                        });
                        //Dra in rörligt elpris från productPrices och slå ihop det med elcertifikat
                        if (type.key == "rorligt") {
                            if (data.productPrices) {
                                var cost = {};
                                cost.id = 999;
                                cost.value = data.productPrices.elCertificate + data.productPrices.purchase;
                                cost.entity = "öre/kWh";
                                cost.name = "Elpris";
                                var purchaseMonth = Date.parseISO(data.productPrices.purchaseStartDate).toFormat("MMMM");
                                cost.info = "Rörligt elpris och elcertifikatsavgift för " + purchaseMonth + " månad";
                                product.variableCosts.unshift(cost);
                                product.variableTotal += cost.value;
                            }
                        }
                        //Slå ihop Elpris och elcertifikat på fast
                        if (type.key == "fast") {
                            var oldPrice = null;
                            var oldCertificate = null;
                            for (var i = 0; i < product.variableCosts.length; i++) {
                                var cost = product.variableCosts[i];
                                if (cost.id == 1) {
                                    oldPrice = cost;
                                    product.variableCosts.splice(i, 1);
                                    i--;
                                }
                                if (cost.id == 2) {
                                    oldCertificate = cost;
                                    product.variableCosts.splice(i, 1);
                                    i--;
                                }
                            }
                            ;
                            if (oldPrice != null && oldCertificate != null) {
                                oldPrice.value = oldPrice.value + oldCertificate.value;
                            }
                            if (oldPrice != null) {
                                product.variableCosts.unshift(oldPrice);
                            }
                        }
                        //räkna ihop total med rabatt
                        product.variableTotalWithDiscount = product.variableTotal + product.variableDiscountsTotal;
                        product.monthlyTotalWithDiscount = product.monthlyTotal + product.monthlyDiscountsTotal;
                        //räkna ut vat med rabatter avdragna
                        product.variableVat = product.variableTotalWithDiscount * 0.25;
                        product.monthlyVat = product.monthlyTotalWithDiscount * 0.25;
                        product.hasDiscount = product.monthlyDiscountsTotal < 0 || product.variableDiscountsTotal < 0;
                        product.estimatedCost = product.monthlyTotal + (((product.variableTotal / 100) * estimatedConsumption) / 12);
                        product.estimatedCostWithDiscount = product.monthlyTotalWithDiscount + (((product.variableTotalWithDiscount / 100) * estimatedConsumption) / 12);
                        product.comparePrices = _this.getComparePrices(product.variableTotal, product.monthlyTotal, product.variableDiscountsTotal, product.monthlyDiscountsTotal);
                        productGroup.products.push(product);
                    });
                    productGroup.selected = productGroup.products && productGroup.products.length > 0 ? productGroup.products[0] : null;
                    productGroup.selectedId = productGroup.selected != null ? productGroup.selected.id : null;
                    productGroups.push(productGroup);
                });
            }
        });
        return productGroups;
    },
    comparePrice: function (kwh, kwhPrice, monthPrice, kwhDiscount, monthDiscount) {
        var comparePrice = 0;
        comparePrice += kwh * (kwhPrice - Math.abs(kwhDiscount));
        comparePrice += 12 * ((monthPrice - Math.abs(monthDiscount)) * 100);
        comparePrice /= kwh;
        return comparePrice;
    },
    getComparePrices: function (kwhPrice, monthPrice, kwhDiscount, monthDiscount) {
        var output = [];
        var consumptionValues = [2000, 5000, 20000];
        for (var n = 0; n < consumptionValues.length; n++) {
            output.push({
                name: consumptionValues[n].toPrettyNumber(0) + " kWh",
                id: "3",
                value: this.comparePrice(consumptionValues[n], kwhPrice, monthPrice, kwhDiscount, monthDiscount),
                entity: "öre/kWh"
            });
        }
        return output;
    },
    parseFacility: function () {
        this.form.facility.value = this.form.facility.value.replace(/^735999/, "");
    },
    aptSizeChanged: function () {
        if (!this.aptSize) {
            this.aptSize = 50;
        }
        this.estimatedConsumption = (this.aptSize * this.consumptionMultiplier);
        if (this.data) {
            this.productGroups = this.parseProducts(this.data, this.estimatedConsumption);
        }
    },
    changeStep: function (dir) {
        if (dir > 0) {
            dir = this.step + dir > this.steps - 1 ? 0 : dir;
        }
        if (dir < 0) {
            dir = this.steps + dir <= 0 ? 0 : dir;
        }
        this.step += dir;
        this.validateStep();
    },
    validateStep: function () {
        switch (this.step) {
            case 1:
                this.steps[this.step].valid = this.form.start.valid && this.form.start.validated;
                break;
            case 2:
                this.steps[this.step].valid = this.form.product.valid && this.form.product.validated;
                break;
            case 3:
                var facility = this.form.facility.valid && this.form.facility.validated;
                var invoice = this.form.invoice.valid && this.form.invoice.validated;
                var netArea = this.form.netArea.valid && this.form.netArea.validated;
                this.steps[this.step].valid = invoice && facility && netArea;
                break;
        }
    },
    validateForm: function () {
        for (var prop in this.form) {
            if (this.form[prop].valid != undefined) {
                if (this.form[prop].valid == false) {
                    this.formValid = false;
                    return;
                }
            }
        }
        this.formValid = true;
    },
    validateFacility: function () {
        var validate = function (value) {
            if (!value.match(/^735999/))
                value = "735999" + value;
            if (value.length < 17)
                return false;
            if (!value.match(/^735999[0-9]{12}$/))
                return false;
            var field = value.substring(0, 17), faktor = 3, index, sum = 0;
            for (index = 18 - 1; index > 0; --index) {
                sum += field.substring(index - 1, index) * faktor;
                sum = sum % 10;
                faktor = 4 - faktor;
            }
            var k = (10 - sum) % 10;
            if (k != value.substring(17, 18))
                return false;
            return true;
        };
        if (this.form.facility.value == "") {
            this.form.facility.valid = false;
            this.form.facility.error = "";
            this.form.facility.validated = false;
            return;
        }
        this.form.facility.valid = validate(this.form.facility.value);
        this.form.facility.error = this.form.facility.valid ? '' : 'Ange korrekt Anläggnings-ID.';
        this.form.facility.validated = true;
    },
    validateInvoice: function () {
        switch (this.form.invoice.value) {
            case 1: //E-post
                this.form.invoice.title = "E-post";
                this.form.invoice.value2 = this.form.invoice.email;
                break;
            case 2: //SMS
                this.form.invoice.title = "SMS";
                this.form.invoice.value2 = this.form.invoice.sms;
                break;
            case 0: //Brev 
                this.form.invoice.title = "Brev";
                this.form.invoice.value2 = "";
                this.form.invoice.valid = true;
                this.form.invoice.validated = true;
                return;
                break;
        }
        if (this.form.invoice.value2 == "") {
            this.form.invoice.valid = false;
            this.form.invoice.validated = false;
            this.form.invoice.error = "";
            return;
        }
        switch (this.form.invoice.value) {
            case 1: //E-post
                this.form.invoice.valid = this.validateEmail(this.form.invoice.value2);
                break;
            case 2: //SMS
                this.form.invoice.valid = this.validatePhone(this.form.invoice.value2);
                break;
            case 0: //Brev 
                this.form.invoice.valid = true;
                break;
        }
        this.form.invoice.validated = true;
    },
    validateNetArea: function () {
        if (this.form.netArea.value == "") {
            this.form.netArea.valid = false;
            this.form.netArea.error = "";
            this.form.netArea.validated = false;
            return;
        }
        this.form.netArea.valid = this.form.netArea.value.match(/^[^\d]{3}$/);
        this.form.netArea.error = this.form.netArea.valid ? '' : 'Ange korrekt Områdes-ID';
        this.form.netArea.validated = true;
    },
    validateDate: function () {
        var date = new Date(this.form.start.value);
        var min = new Date(this.firstPossible);
        this.form.start.valid = date >= min;
        this.form.start.error = "";
        this.form.start.validated = true;
    },
    validateProduct: function () {
        this.form.product.valid = this.form.product.value != '';
        this.form.product.error = this.form.product.valid ? '' : '';
        this.form.product.validated = true;
    },
    validatePhone: function (value) {
        return value.match(/^\+(?:[0-9]●?){6,14}[0-9]$/);
    },
    validateEmail: function (value) {
        return value.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    },
    isMobile: function (opts) {
        var mobileRE = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser.*mobile|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;
        var notMobileRE = /CrOS/;
        var tabletRE = /android|ipad|playbook|silk/i;
        if (!opts)
            opts = {};
        var ua = opts.ua;
        if (!ua && typeof navigator !== 'undefined')
            ua = navigator.userAgent;
        if (ua && ua.headers && typeof ua.headers['user-agent'] === 'string') {
            ua = ua.headers['user-agent'];
        }
        if (typeof ua !== 'string')
            return false;
        var result = (mobileRE.test(ua) && !notMobileRE.test(ua)) ||
            (!!opts.tablet && tabletRE.test(ua));
        if (!result &&
            opts.tablet &&
            opts.featureDetect &&
            navigator &&
            navigator.maxTouchPoints > 1 &&
            ua.indexOf('Macintosh') !== -1 &&
            ua.indexOf('Safari') !== -1) {
            result = true;
        }
        return result;
    },
    openAutoStart: function () {
        var url = "bankid:///?autostarttoken=" + this.bankIdAutoStartToken + "&redirect=null";
        window.open(url, "_blank");
    },
    setQrCode: function (base64) {
        this.base64QRCode = base64 ? "data:image/png;base64, " + base64 : "";
    },
    signStart: function () {
        var _this = this;
        this.showSign = true;
        this.showSignError = false;
        this.bankIdAutoStartToken = "";
        this.base64QRCode = "";
        var data = {
            "product-api": "signstart",
            pin: this.form.details.ssn,
            startDate: this.form.start.value,
            zipcode: this.form.details.zipCode,
            signWithQRCode: true
        };
        var ajax = new AjaxRequest();
        ajax.Send(AjaxMethod.GET, this.apiUrl, data, { ResponseType: AjaxResponseType.JSON }).then(function (result) {
            console.log("SignStart", result);
            console.log((result.data.success && result.data.result.BankIdOrderRef), result.data.success, result.data.result.BankIdOrderRef);
            _this.setQrCode(result.data.result.base64QRCode);
            if (result.data.success && result.data.result.BankIdOrderRef) {
                _this.bankIdAutoStartToken = result.data.result.BankIdAutoStartToken;
                _this.checkSign(result.data.result.BankIdOrderRef, result.data.result.responseDate);
            }
            else {
                _this.showSign = false;
                _this.showSignError = true;
            }
        }, function (error) {
            _this.showSign = false;
            _this.showSignError = true;
        });
    },
    checkSign: function (bankIdOrderRef, responseDate) {
        var _this = this;
        var data = {
            "product-api": "signstatus",
            BankIdOrderRef: bankIdOrderRef,
            BankIdAutoStartToken: this.bankIdAutoStartToken,
            responseDate: responseDate,
            signWithQRCode: true,
            unique: (new Date()).getTime()
        };
        var attempts = 0;
        var maxAttempts = 100;
        var interval = 2000;
        var check = function () {
            attempts++;
            data.unique = (new Date()).getTime();
            var ajax = new AjaxRequest();
            ajax.Send(AjaxMethod.GET, _this.apiUrl, data, { ResponseType: AjaxResponseType.JSON }).then(function (result) {
                console.log("SignStatus", result);
                if (result.data.success) {
                    _this.setQrCode(result.data.result.base64QRCode);
                    if (result.data.result.SignedStatus == 1) {
                        _this.saveAgreement(bankIdOrderRef);
                    }
                    else if (result.data.result.ProgressStatusCode == "PENDING") {
                        if (maxAttempts && attempts === maxAttempts) {
                            console.log("failed maxattempts");
                            _this.showSign = false;
                            _this.showSignError = true;
                        }
                        else if (_this.showSign) {
                            setTimeout(check, interval);
                        }
                    }
                    else if (result.data.result.ProgressStatusCode == "FAILED") {
                        console.log("failed/canceled");
                        _this.showSign = false;
                        _this.showSignError = true;
                    }
                }
                else if (_this.showSign) {
                    setTimeout(check, interval);
                }
            }, function (error) {
                console.log("checkSign error: ", error);
            });
        };
        check();
    },
    cancelSign: function () {
        this.showSign = false;
    },
    saveAgreement: function (bankIdOrderRef) {
        var _this = this;
        var name = this.form.details.name.split(" ");
        var firstname = name.length > 0 ? name[0] : "";
        var lastname = name.length > 1 ? name[1] : "";
        var data = {
            "product-api": "sign",
            bankIdOrderRef: bankIdOrderRef,
            pin: this.form.details.ssn,
            email: this.form.details.email,
            phone: this.form.details.phone,
            firstname: firstname,
            lastname: lastname,
            address: this.form.details.address,
            city: this.form.details.city,
            zipcode: this.form.details.zipCode,
            billingAddress: this.form.details.address,
            billingZipcode: this.form.details.zipCode,
            billingCity: this.form.details.city,
            startDate: this.form.start.value,
            authority: false,
            terms: this.summary.accept,
            estimation: this.estimatedConsumption,
            additionalProduct: this.summary.additionalProducts,
            invoiceDistId: this.form.invoice.value,
            invoiceDistValue: this.form.invoice.value2,
            product: this.form.product.value.id,
            id: this.offer.id,
            facilityId: "735999" + this.form.facility.value,
            areaId: this.form.netArea.value,
            memberNumber: this.externalId
        };
        console.log("saveAgreement", data);
        var ajax = new AjaxRequest();
        ajax.Send(AjaxMethod.GET, this.apiUrl, data, { ResponseType: AjaxResponseType.JSON }).then(function (result) {
            console.log("saveAgreement", result);
            _this.showSign = false;
            if (result.data.success && result.data.result && result.data.result.sign) {
                _this.signId = result.data.result.sign.id ? result.data.result.sign.id : null;
                _this.showComplete = true;
            }
            else {
                _this.showAgreementError = true;
                var errors = [];
                for (var prop in result.data.result) {
                    errors.push(result.data.result[prop]);
                }
                _this.agreementErrors = errors;
            }
        }, function (error) {
            console.log("saveAgreement error: ", error);
            _this.showSign = false;
            _this.showAgreementError = true;
        });
    }
}); });
/*
Alpine.data('animatedText', () => ({
    numberOfElements: 25,
    durationInSeconds: 2,
    timeout: 2000,
    elementOptions: [
        `<circle r="3" />`,
        `<path d="M3.83733 4.73234C4.38961 4.73234 4.83733 4.28463 4.83733 3.73234C4.83733 3.18006 4.38961 2.73234 3.83733 2.73234C3.28505 2.73234 2.83733 3.18006 2.83733 3.73234C2.83733 4.28463 3.28505 4.73234 3.83733 4.73234ZM3.83733 6.73234C5.49418 6.73234 6.83733 5.38919 6.83733 3.73234C6.83733 2.07549 5.49418 0.732341 3.83733 0.732341C2.18048 0.732341 0.83733 2.07549 0.83733 3.73234C0.83733 5.38919 2.18048 6.73234 3.83733 6.73234Z" />`,
        `<path d="M4.29742 2.26041C3.86864 2.1688 3.20695 2.21855 2.13614 3.0038C1.69078 3.33041 1.06498 3.23413 0.738375 2.78876C0.411774 2.3434 0.508051 1.7176 0.953417 1.39099C2.32237 0.387097 3.55827 0.0573281 4.71534 0.304565C5.80081 0.536504 6.61625 1.24716 7.20541 1.78276C7.28295 1.85326 7.35618 1.92051 7.4263 1.9849C7.64841 2.18888 7.83929 2.36418 8.03729 2.52315C8.29108 2.72692 8.48631 2.8439 8.64952 2.90181C8.7915 2.95219 8.91895 2.96216 9.07414 2.92095C9.24752 2.8749 9.5134 2.7484 9.88467 2.42214C10.2995 2.05757 10.9314 2.09833 11.2959 2.51319C11.6605 2.92805 11.6198 3.5599 11.2049 3.92447C10.6816 4.38435 10.1478 4.70514 9.58752 4.85394C9.00909 5.00756 8.469 4.95993 7.9807 4.78667C7.51364 4.62093 7.11587 4.34823 6.78514 4.08268C6.53001 3.87783 6.27248 3.64113 6.04114 3.4285C5.97868 3.37109 5.91814 3.31544 5.86006 3.26264C5.25645 2.7139 4.79779 2.36733 4.29742 2.26041Z" />`,
        `<rect width="4" height="4" x="-2" y="-2" />`,
        `<path d="M -5 5 L 0 -5 L 5 5 Z" />`,
    ],
    colors: ["#702082", "#500778", "#C9B1D0"],
    elements: [],
    getRandomNumber(min, max){
        return Math.random() * (max - min) + min;
    },
    getRandom(items){
        return items[Math.round(Math.random() * (items.length - 1))]
    },
    quadIn(t: number) {
        return t * t;
    },
    init(){
        
        this.elements = new Array(this.numberOfElements);
        this.elements = this.elements.fill(0);
        this.elements = this.elements.map((_, i) => [this.getRandom(this.elementOptions), this.getRandom(this.colors), Math.random()]);

    },
    render(){
        let output: string = "";
        output += '<svg class="confetti" viewBox="-10 -10 10 10">';
        
        for(let i: number = 0;i<this.elements.length;i++){
            let element: Array<any> = this.elements[i];
            output +=
            `<g style="transform: scale(${element[2]}">
                <g fill="${element[1]}"
                    style="--rotation: ${Math.random() * 360}deg; animation-delay: ${this.quadIn(i / this.numberOfElements)}s; animation-duration: ${this.durationInSeconds * this.getRandomNumber(0.7, 1)}s;'">
                    ${element[0]}
                </g>
            </g>`;
        }
        
        output += '</svg>';
        return output;
    }
}));
*/
Alpine.start();
